import React from "react";
import { Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Slider from '@material-ui/core/Slider';
import Box from '@material-ui/core/Box';
import { selectCompany } from "../../redux/reducers/chart-reducer";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as dfd from "dataframe-js";
import { chartDataCorrector } from "../../utils/chartDataCorrectors";

const marks = [
  {
    value: 0,
    label: '0',
  },
  {
    value: 100,
    label: '100',
  },
];

const weightParams = {nWeight:0.25, wWeight:0.25, tWeight:0.25, rWeight:0.25}

const rounded = (number) => {
  return +number.toFixed(2);
}


export const ChartSlider = (changeState) => {

  let { selectedCompany } =
  useSelector(selectCompany);



const [n, setN] = useState(50);
const [w, setW] = useState(50);
const [t, setT] = useState(50);
const [r, setR] = useState(50);
const [npt, setNPT] = useState(50);

const weightCalc = () => {

  weightParams["nWeight"] =   Math.round(n  *20/100+((20-w*20/100)*((n+t+r+npt > 0) ? n/(n+t+r+npt) : 0)) +   (20-t*20/100)*(((n+w+r+npt) > 0) ? n/(n+w+r+npt) : 0)+  (20-r*20/100)*((n+w+t+npt > 0) ? n/(n+w+t+npt) : 0)+  (20-npt*20/100)*((n+w+t+r > 0) ? n/(n+w+t+r) : 0));
  weightParams["wWeight"] =   Math.round(w  *20/100+((20-n*20/100)*((w+t+r+npt > 0) ? w/(w+t+r+npt) : 0)) +   (20-t*20/100)*(((n+w+r+npt) > 0) ? w/(n+w+r+npt) : 0)+  (20-r*20/100)*((n+w+t+npt > 0) ? w/(n+w+t+npt) : 0)+  (20-npt*20/100)*((n+w+t+r > 0) ? w/(n+w+t+r) : 0));  
  weightParams["tWeight"] =   Math.round(t  *20/100+((20-n*20/100)*((w+t+r+npt > 0) ? t/(w+t+r+npt) : 0)) +   (20-w*20/100)*(((n+t+r+npt) > 0) ? t/(n+t+r+npt) : 0)+  (20-r*20/100)*((n+w+t+npt > 0) ? t/(n+w+t+npt) : 0)+  (20-npt*20/100)*((n+w+t+r > 0) ? t/(n+w+t+r) : 0));    
  weightParams["rWeight"] =   Math.round(r  *20/100+((20-n*20/100)*((w+t+r+npt > 0) ? r/(w+t+r+npt) : 0)) +   (20-w*20/100)*(((n+t+r+npt) > 0) ? r/(n+t+r+npt) : 0)+  (20-t*20/100)*((n+w+r+npt > 0) ? r/(n+w+r+npt) : 0)+  (20-npt*20/100)*((n+w+r+t > 0) ? r/(n+w+r+t) : 0));    
  weightParams["nptWeight"] = Math.round(npt*20/100+((20-n*20/100)*((w+t+r+npt > 0) ? npt/(w+t+r+npt) : 0))   + (20-w*20/100)*(((n+t+r+npt) > 0) ?   npt/(n+t+r+npt) : 0)+(20-t*20/100)*((n+w+r+npt > 0) ?   npt/(n+w+r+npt) : 0)+(20-r*20/100)*  ((n+w+npt+t > 0) ? npt/(n+w+npt+t) : 0));    


    let crewsTotal = new Array();

    selectedCompany.contractors.forEach(contractor => {
      crewsTotal = crewsTotal.concat(contractor.crews);
    });

    let df = new dfd.DataFrame(crewsTotal);
    selectedCompany['nmax'] = df.stat.max('n');
    selectedCompany['wmax'] = df.stat.max('w');
    selectedCompany['tmax'] = df.stat.max('t');
    selectedCompany['rmax'] = df.stat.max('r');      
    selectedCompany['nptmax'] = df.stat.max('NPT');      


    selectedCompany.contractors.forEach(contractor => {
      
      contractor.crews.forEach( crew => {
        crew["N"] = (crew.n/selectedCompany.nmax)*weightParams.nWeight
        crew["W"] = (crew.w/selectedCompany.wmax)*weightParams.wWeight
        crew["T"] = (crew.t/selectedCompany.tmax)*weightParams.tWeight
        crew["R"] = (crew.r/selectedCompany.rmax)*weightParams.rWeight
        crew["NPT2"] = (crew.NPT/selectedCompany.nptmax)*weightParams.nptWeight
        crew["KPI"] = rounded(100 - crew["N"] - crew["W"] - crew["T"] - crew["R"] - crew["NPT2"]);
      });
      df = new dfd.DataFrame(contractor.crews);
      contractor['KPI'] = rounded(df.stat.sum('KPI')/df.count());

    });

    changeState.changeState(chartDataCorrector(selectedCompany));
//      data.setState({
//        data: chartDataCorrector(selectedCompany)
//      }) 






}

const NChange = (val) => {
  setN(val);
  weightCalc();
}

const WChange = (val) => {
  setW(val);
  weightCalc();
}

const TChange = (val) => {
  setT(val);
  weightCalc();
}

const RChange = (val) => {
  setR(val);
  weightCalc();
}

const NPTChange = (val) => {
  setNPT(val);
  weightCalc();
}

return (
  <Paper style={{ height: "500px", width: "100%" }}>
      <Box sx={{ width: 400, margin:15}}>
      <h1>Вес параметров</h1>
      </Box>
      <Box sx={{ width: 400, margin:15}}>
      Количество нарушений  
      <Slider
          defaultValue={50}
          step={1}
          valueLabelDisplay="auto"
          marks={marks}
          onChange={(e, val) => NChange(val)}
          value = {n}
      />
      </Box>
      <Box sx={{ width: 400, margin:15 }}>
      Тяжесть нарушений  
      <Slider
          defaultValue={50}
          step={1}
          valueLabelDisplay="auto"
          marks={marks}
          onChange={(e, val) => WChange(val)}
          value = {w}
      />
      </Box>
      <Box sx={{ width: 400, margin:15 }}>
      Время устранения  
      <Slider
          defaultValue={50}
          step={1}
          valueLabelDisplay="auto"
          marks={marks}
          onChange={(e, val) => TChange(val)}
          value = {t}            
      />
      </Box>
      <Box sx={{ width: 400, margin:15 }}>
      Повтор нарушений  
      <Slider
          defaultValue={50}
          step={1}
          valueLabelDisplay="auto"
          marks={marks}
          onChange={(e, val) => RChange(val)}
          value = {r}
      />
      </Box>
      <Box sx={{ width: 400, margin:15 }}>
      Непроизводительное время  
      <Slider
          defaultValue={50}
          step={1}
          valueLabelDisplay="auto"
          marks={marks}
          onChange={(e, val) => NPTChange(val)}
          value = {npt}
      />
      </Box>      
      </Paper>
);
};